<mat-form-field class="happ-small-form-field-outline" floatLabel="always" appearance="outline" style="min-width: 180px;;">
  <mat-label>{{ fieldTitle | translate }}</mat-label>
  <mat-select (selectionChange)="onChange($event)" [(ngModel)]="model" >
    <mat-optgroup  *ngFor="let subHeading of dateList" [label]="subHeading.subHeading | translate">
      <mat-option *ngFor="let list of subHeading.list" [value]="list.value">
        {{ list.title | translate }}
      </mat-option>
    </mat-optgroup>
  </mat-select>
</mat-form-field>